import { IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested, IsEnum } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { OneToMany } from 'typeorm';
import { PlantsEnum, SubPlantCodesEnum } from '@gtpl/shared-models/common-models';

export class GrnDTO {
  @ApiProperty()
  @IsOptional()
  grnId?: number;

  @ApiProperty()
  @IsNotEmpty({ message: "GRN Date should not be empty" })
  grnDate: Date;

  @ApiProperty()
  @IsNotEmpty({ message: "Indent Number should not be empty" })
  indentId: number;

  @ApiProperty()
  @IsOptional()
  grnNumber?: string;

  @ApiProperty()
  @IsOptional()
  lotNumber?: string;

  @ApiProperty()
  @IsOptional()
  saleOrderId?: number;

  @ApiProperty()
  @IsOptional()
  saleOrderItemId?: number;

  @ApiProperty()
  @IsNotEmpty({ message: "Supplier Type should not be empty" })
  supplierType: string;

  @ApiProperty()
  @IsNotEmpty({ message: "Farmer should not be empty" })
  farmer: number;

  @ApiProperty()
  @IsNotEmpty({ message: "Farmer Code should not be empty" })
  // @IsAlphanumeric()
  farmerCode: number;

  @ApiProperty()
  @IsNotEmpty({ message: "Quantity should not be empty" })
  quantity: number;

  @ApiProperty()
  @IsNotEmpty({ message: "Count should not be empty" })
  count: number;

  @ApiProperty()
  // @IsNotEmpty({message:"Price should not be empty"})
  price: number;

  @ApiProperty()
  // @IsNotEmpty({message:"Price should not be empty"})
  boxes: number;
  
  @ApiProperty()
  // @IsEnum(PlantsEnum)
  plantId: number;

  @ApiProperty()
  // @IsEnum(PlantsEnum)
  subPlantId: number;


  // @ApiProperty({
  //   enum: SubPlantCodesEnum
  // })
  // // @IsEnum(SubPlantCodesEnum)
  // subPlantId: SubPlantCodesEnum;


  @ApiProperty()
  isActive: boolean;

  @ApiProperty()
  createdAt: Date;

  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Created User allows maximum 40 characters" })
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), { message: "created user should be only numbers" })
  createdUser: string;

  updatedAt: Date;
  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Updated User allows maximum 40 characters" })
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), { message: "updated user should be only numbers" })
  updatedUser: string;

  @ApiProperty()
  versionFlag: number;
  @IsOptional()
  isVInspectionCompleted: boolean;
  @IsOptional()
  isRmInspectionCompleted: boolean;
  @IsOptional()
  isAntibioticsTestCompleted: boolean;
  @ApiProperty()
  @IsOptional()
  receivedBoxes?: number;
  
  @ApiProperty()
  @IsOptional()
  softPercentage?: number;

  @ApiProperty()
  @IsOptional()
  fungusPercentage?: number;

  @ApiProperty()
  @IsOptional()
  looseShell?: string;

  @ApiProperty()
  @IsOptional()
  remarks?: string;
 
}
